import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { OrderService } from 'src/app/services/order.service';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { PdfVirtualViewerComponent } from 'src/app/shared-components/pdf-virtual-viewer/pdf-virtual-viewer.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { ESignService } from 'src/app/services/e-sign.service';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ClientDetailsService } from 'src/app/services/client-details.service';
import { WebcamImage, WebcamInitError } from 'ngx-webcam';
import { StorageService } from 'src/app/services/storage.service';
import { UrlValidatorService } from 'src/app/services/url-validator.service';
import { DomainType } from 'src/app/enum/domain-type.enum';
import { environment } from 'src/environments/environment';
import { getSignatureBoxSizePx } from 'src/app/shared-components/signature-box.util';
interface Coordinates {
  x1: number;
  x2: number;
  y1: number;
  y2: number;
}

interface PositionDetails {
  [key: string]: Coordinates[];
}
@Component({
    selector: 'app-aadhaar-link',
    templateUrl: './aadhaar-link.component.html',
    styleUrls: ['./aadhaar-link.component.scss'],
    standalone: false
})
export class AadhaarLinkComponent implements OnInit {
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  @ViewChild('otpScreen') otpScreen: TemplateRef<any>;
  @ViewChild('userImage') userImage: TemplateRef<any>;
  @ViewChild('emudhraSignDSC') emudhraSignDSC: TemplateRef<any>;
  @ViewChild('geoFencingModal') geoFencingModal: TemplateRef<any>;
  @ViewChild('fileCorruptedModal') fileCorruptedModal: TemplateRef<any>;
  @ViewChild('scrollPane') scrollPaneRef?: ElementRef<HTMLDivElement>;
  @ViewChild('pdfViewer') pdfViewer?: PdfVirtualViewerComponent;

  showFileCorruptedDialog: boolean = false;
  geoFencingData: any;
  isGeoFencingAllowed: boolean = true;
  showSign: boolean = true;
  contentData: any;
  showOtpMethod: boolean = true;
  pdfSource: SafeResourceUrl;
  emudhraParms: any = {};
  showOtpComponent: boolean = true;
  selectMethod: string;
  parameters: { Parameter1: string; Parameter2: string; Parameter3: string };
  aadhaarParms: any;
  signTypeDSC: boolean = false;
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.showSign = window.innerWidth > 740;
  }
  isChecked: boolean = false;
  selectedConsentLang: string = 'en';
  consentLanguages = [
    { code: 'en', label: 'English' },
    { code: 'hi', label: 'हिन्दी' },
    { code: 'bn', label: 'বাংলা' },
    { code: 'te', label: 'తెలుగు' },
    { code: 'mr', label: 'मराठी' },
    { code: 'ta', label: 'தமிழ்' },
    { code: 'gu', label: 'ગુજરાતી' },
    { code: 'kn', label: 'ಕನ್ನಡ' },
    { code: 'or', label: 'ଓଡ଼ିଆ' },
    { code: 'ml', label: 'മലയാളം' },
    { code: 'pa', label: 'ਪੰਜਾਬੀ' },
    { code: 'as', label: 'অসমীয়া' },
  ];
  safePdfSource: SafeResourceUrl;
  orderId: string;
  pdfUrl: Uint8Array | null = null;
  signatoryDetails: any = {};
  queryParams: any;
  signerData: any = [];
  pageCheck: any;

  signPages: number[];
  urlSource: string | any;
  signOption: string = 'select';

  public webcamImage: WebcamImage = null;
  showWebcam: boolean;
  private pageSizesPx: ({ width: number; height: number } | undefined)[] = [];
  positionDetails: any = [];

  get totalSignaturePositions(): number {
    const positionsByPage: any = this.positionDetails || {};
    return Object.keys(positionsByPage).reduce(
      (total: number, page: string) => total + (positionsByPage[page]?.length || 0),
      0
    );
  }

  get overlayPages(): Set<number> {
    return new Set(Object.keys(this.positionDetails || {}).map(Number));
  }

  pageVariable = 1;
  numPdfPages: any = 1;
  // HASH eSign: the signer signs the SHA-256 of the client's document; there
  // is no PDF to display, only the hash.
  isHashSign: boolean = false;
  // HASH: an earlier signer in the sequence hasn't signed yet, so this signer can't start.
  hashWaiting: boolean = false;
  documentHash: string = '';
  hashAlgorithm: string = '';
  hashFilename: string = '';
  pageNo: number = 1;

  getPageHeight(pageNum: number): number {
    return this.pageSizesPx[pageNum - 1]?.height ?? this.convertPtToPx(842);
  }

  getPageWidth(pageNum: number): number {
    return this.pageSizesPx[pageNum - 1]?.width ?? this.convertPtToPx(595);
  }

  otherSignerDetails: any = [];
  beforeSigners: any = [];
  afterSigners: any = [];
  esignId: string;
  signatoryId: string;
  zeroSigners: any = [];
  pageHeight: number;
  ipAddress: any;
  isDocumentSigned: boolean = false;
  isEstampPending: boolean = false;
  modalContent: SafeHtml | undefined;
  private popupWindow: Window | null = null;
  signPosition: string | undefined;
  selectedVerificationMethod: string | undefined;
  aadhaarVerificationMethod = [
    { name: 'OTP', code: 'OTP', inactive: false },
    { name: 'Biometric', code: 'Fingerprint', inactive: false },
    { name: 'Face Recognition', code: 'FaceRecognition', inactive: false },
  ];
  userData: {
    ip_address: string;
    latitude: number;
    longitude: number;
    browser: string;
    device_type: string;
    timeStamp: any;
    location: any;
    city: any;
    state: any;
    country: any;
  };
  completedSigners: any = [];
  displayCamera: boolean = true;
  showFinish: boolean = true;

  interval: any;
  selectedUserEmail: any;
  timeLeft: number = 60;
  validOTP: boolean = false;
  otp!: string;
  sendOtp: boolean = false;
  sendOtpLink: boolean = false;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
  };
  enableOtp: boolean = true;
  enableCaptureImage: boolean = true;
  showEmudhra: boolean = false;

  isLoading: boolean = false;
  displayConsentModal = false;
  private isClosingModal: boolean = false;
  private consentShown: boolean = false;
  isSignFailed: boolean = false;
  isEmailButtonDisabled: boolean = false;
  emailCooldownTime: number = 0;
  private emailCooldownInterval: any;

  // ── Session auto-refresh timer (5 minutes) ──
  sessionTimeLeft: number = 5 * 60;
  private sessionTimerInterval: any;

  constructor(
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private activeRouter: ActivatedRoute,
    private eSignService: ESignService,
    private messageService: MessageService,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private clientDetailsService: ClientDetailsService,
    private http: HttpClient,
    private storageService: StorageService,
    private router: Router,
    private urlValidator: UrlValidatorService,
    private orderService: OrderService,
    private analyticsService: AnalyticsService,
    private cdr: ChangeDetectorRef,
    public translate: TranslateService
  ) {
    this.translate.setDefaultLang('en');
    this.translate.use('en');
    this.activeRouter.queryParams.subscribe((queryParams) => {
      this.queryParams = queryParams;
      this.esignId = this.queryParams.esign_id;
      this.signatoryId = this.queryParams.signatory_id;
    });

    this.showSign = window.innerWidth > 740;
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.spinner.hide();
    this.renderer.setStyle(document.body, 'overflow-y', 'hidden');
    this.getSignerDetails();
    this.getClientData();
    this.openCam();
    const urlParams = new URLSearchParams(window.location.search);
    const retryParam = urlParams.get('retry');

    if (retryParam === 'true') {
      this.showFileCorruptionModal();
    }

    // Sent back by the eMudhra callback: another signatory completed while
    // this signer was on eMudhra, so their signature was not applied.
    if (urlParams.get('reason') === 'documentUpdated') {
      this.messageService.add({
        severity: 'warn',
        summary: 'Please sign again',
        detail: 'Another signatory signed this document while you were signing. Please sign again.',
        sticky: true,
      });
    }

    this.startSessionTimer();
  }

  // Starts a 5-minute countdown. When it reaches 0 the page auto-refreshes.
  startSessionTimer() {
    clearInterval(this.sessionTimerInterval);
    this.sessionTimeLeft = 5 * 60;
    this.sessionTimerInterval = setInterval(() => {
      if (this.sessionTimeLeft > 0) {
        this.sessionTimeLeft--;
        this.cdr.detectChanges();
      } else {
        clearInterval(this.sessionTimerInterval);
        window.location.reload();
      }
    }, 1000);
  }

  // Formats seconds as MM:SS for display.
  get sessionTimerDisplay(): string {
    const minutes = Math.floor(this.sessionTimeLeft / 60);
    const seconds = this.sessionTimeLeft % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  }

  ngOnDestroy() {
    if (this.emailCooldownInterval) {
      clearInterval(this.emailCooldownInterval);
    }
    if (this.sessionTimerInterval) {
      clearInterval(this.sessionTimerInterval);
    }
  }

  //-------------------------------------- Get Signer Details ----------------------------------//

  getSignerDetails() {
    this.eSignService.getSignerDetails(this.queryParams).subscribe(
      (res) => {
        if (res['message'] === 'Signatory not found') {
          this.signerData = { signatory_details: { status: 'EXPIRED' } };
          this.signatoryDetails = this.signerData.signatory_details;
          this.isDocumentSigned = true;
          this.spinner.hide();
          this.cdr.detectChanges();
          return;
        }

        if (
          res['message'] === 'No data found' ||
          !res['content'] ||
          Object.keys(res['content']).length === 0
        ) {
          this.isEstampPending = true;
          this.spinner.hide();
          this.cdr.detectChanges();
          return;
        }

        this.signerData = res['content'];
        this.isEstampPending = res['content'].estamp_done === false;
        if (this.isEstampPending) {
          this.spinner.hide();
          this.cdr.detectChanges();
          return;
        }
        this.isHashSign = res['content'].sign_type === 'HASH';
        if (this.isHashSign) {
          this.hashWaiting = res['content'].waiting_for_earlier_signers === true;
          this.documentHash = res['content'].document_hash || '';
          this.hashAlgorithm = res['content'].hash_algorithm || 'SHA-256';
          this.hashFilename = res['content'].filename || '';
        } else {
          this.pdfUrl = this.base64ToUint8Array(res['content'].document);
        }
        this.signatoryDetails = this.signerData.signatory_details;
        this.enableCaptureImage = this.signatoryDetails.esign_webcam;
        this.signPosition = this.signatoryDetails.sign_position;
        this.selectedUserEmail = this.signatoryDetails.email;
        this.selectMethod = this.signatoryDetails.sign_method;
        this.orderId = this.signerData.order_id;
        this.emudhraParms = this.signatoryDetails.emudhra_gateway;
        this.selectedVerificationMethod = this.signatoryDetails.sign_mode || 'OTP';

        if (this.signatoryDetails.status === 'FAILED') {
          this.isSignFailed = true;
          this.router.navigate(['signFailed']);
          return;
        }

        if (this.emudhraParms && Object.keys(this.emudhraParms).length != 0) {
          this.showEmudhra = true;
          // The stored link may be empty or already used; Sign Now fetches a
          // fresh one, so don't abort the rest of the page setup over it.
          const signUrl = this.signatoryDetails.sign_url;
          if (this.selectMethod === 'AADHAAR') {
            this.signTypeDSC = false;
            this.aadhaarParms =
              this.signatoryDetails.emudhra_gateway.aadhaar_param;
            if(this.urlValidator.isValidRedirectUrl(signUrl, DomainType.EMUDHRA)){
              this.pdfSource = this.sanitizer.bypassSecurityTrustResourceUrl(signUrl);
            }
          } else if (this.selectMethod === 'DSC') {
            this.signTypeDSC = true;
            if(this.urlValidator.isValidRedirectUrl(signUrl, DomainType.EMUDHRA)){
              this.pdfSource = this.sanitizer.bypassSecurityTrustResourceUrl(signUrl);
            }
            this.parameters = {
              Parameter1: this.signatoryDetails.emudhra_gateway.Parameter1,
              Parameter2: this.signatoryDetails.emudhra_gateway.Parameter2,
              Parameter3: this.signatoryDetails.emudhra_gateway.Parameter3,
            };
          }
        } else {
          this.otherSignerDetails = this.signerData.other_signatories;
          const signUrl = this.signatoryDetails.sign_url;
          if (this.urlValidator.isValidRedirectUrl(signUrl, DomainType.EMUDHRA)) {
            this.urlSource =
              this.sanitizer.bypassSecurityTrustResourceUrl(signUrl);
          } else {
            return;
          }
        }

        this.positionDetails = this.signatoryDetails.position_details;
        if (
          this.signatoryDetails.status === 'COMPLETED' ||
          this.signatoryDetails.status === 'CANCELLED' ||
          this.signatoryDetails.status === 'EXPIRED'
        ) {
          this.isDocumentSigned = true;
        }

        this.getSequenceOrder();

        if (!this.isDocumentSigned && !this.consentShown) {
          if (this.showOtpMethod && this.signatoryDetails.esign_otp) {
            this.onOtpMethod();
            this.showOtpMethod = false;
            // Consent will open after OTP is verified (in otpOnSubmit)
          } else {
            this.displayConsentModal = true;
            this.consentShown = true;
          }
        }
        if (this.orderId) {
          this.getIpGeofencing();
        } else {
          console.error('Order ID is undefined, cannot check geo-fencing');
        }
        this.cdr.detectChanges();
      },
      (error) => {
        console.error('Error fetching signer details:', error);
      }
    );
  }

  showGeoFencingModal() {
    this.modalService
      .open(this.geoFencingModal, {
        centered: true,
        backdrop: 'static',
        keyboard: false,
        windowClass: 'geo-fencing-modal', // Specific class for this modal
      })
      .result.then((result) => {
        if (result === 'close') {
          const apiUrl = environment.apiURL;
          const url = new URL(apiUrl);
          url.hostname = url.hostname.replace('-api', '');
          const finalUrl = url.toString();
          if(this.urlValidator.isValidRedirectUrl(finalUrl, DomainType.DOQFY)){
            window.location.href = finalUrl;
          }
        }
      });
  }

  getIpGeofencing() {
    const queryParams = { order_id: this.orderId };
    this.eSignService.getIpGeofencing(queryParams).subscribe(
      (res) => {
        this.geoFencingData = res.content;
        if (res.content.allowed_ip === false) {
          this.showGeoFencingModal();
        }
      },
      (error) => {
        console.error('Error fetching geo-fencing data:', error);
        this.isGeoFencingAllowed = true;
      }
    );
  }

  // openPopup(content) {
  //   this.eSignService
  //     .getExternalSignLink(this.signatoryId, this.orderId)
  //     .subscribe((res) => {
  //       if (res['content'] && Object.keys(res['content']).length === 0) {
  //         this.messageService.add({ severity: 'warn', detail: res['message'] });
  //         return;
  //       } else {
  //         this.contentData = content;
  //         this.sendUserDetails();
  //         this.closeCam();
  //         if (this.urlSource) {
  //           window.location.href = this.urlSource;
  //         }
  //       }
  //     });
  // }

openPopup(content) {
  if (this.enableCaptureImage && !this.webcamImage) {
    this.messageService.add({
      severity: 'error',
      summary: 'Image Required',
      detail: 'Camera access is required. Please ensure your webcam is enabled and photo is captured properly.'
    });
    return;
  }

  this.eSignService.sendUserDetails({
    browser_data: this.userData,
    esign_id: this.esignId,
    signatory_id: this.signatoryId,
    user_image: this.webcamImage
  }).subscribe({
    next: () => {
      this.eSignService.getExternalSignLink(this.signatoryId, this.orderId,this.selectMethod,this.selectedVerificationMethod).subscribe((res: any) => {
        if (res['content'] && Object.keys(res['content']).length === 0) {
          this.messageService.add({ severity: 'warn', detail: res['message'] });
          this.eSignService.checkForImageCaptureRefresh(res['message']);
          return;
        } else {
          this.contentData = content;
          this.closeCam();
          if (this.urlSource) {
            window.location.href = this.urlSource;
          }
        }
      });
    },
    error: (err) => {
      const errMsg = err?.error?.message || 'Audit trail verification failed. Please allow camera access.';
      this.messageService.add({
        severity: 'error',
        summary: 'Verification Failed',
        detail: errMsg
      });
      this.eSignService.checkForImageCaptureRefresh(errMsg);
    }
  });
}

  onPopupClosed() {
    this.closeCam();
  }

  getSequenceOrder() {
    this.beforeSigners = [];
    this.afterSigners = [];
    if (this.otherSignerDetails.length > 0) {
      this.otherSignerDetails.forEach((element) => {
        if (
          element.signatory_sequence >
            this.signatoryDetails.signatory_sequence ||
          element.status != 'COMPLETED'
        ) {
          this.afterSigners.push(element);
        } else if (element.signatory_sequence === 0) {
          this.zeroSigners.push(element);
        } else if (
          element.signatory_sequence === 0 &&
          element.status === 'COMPLETED'
        ) {
          this.beforeSigners.push(element);
        }
        if (element.status === 'COMPLETED') {
          this.completedSigners.push(element);
        }
      });
    }
  }

  getClientData() {
    this.clientDetailsService.getClientDetails().then((res) => {
      this.userData = {
        ip_address: res.ip_address,
        latitude: res.latitude,
        longitude: res.longitude,
        browser: res.device_info.browser,
        device_type: res.device_info.deviceType,
        timeStamp: res.timeStamp,
        location: '--',
        city: '--',
        state: '--',
        country: '--',
      };
      setTimeout(() => {
        this.getLocationDetails(res);
      }, 1000);
    });
  }

  getLocationDetails(res) {
    this.clientDetailsService
      .getLocationDetails(res.latitude, res.longitude)
      .subscribe((loc: any) => {
        this.userData = {
          ip_address: res.ip_address,
          latitude: res.latitude,
          longitude: res.longitude,
          browser: res.device_info.browser,
          device_type: res.device_info.deviceType,
          timeStamp: res.timeStamp,
          location: loc.display_name || '--',
          city: loc.address?.state_district || loc.address?.city || '--',

          state: loc.address?.state || '--',
          country: loc.address?.country || '--',
        };
      });
  }

  // sendUserDetails() {
  //   if (this.userData) {
  //     if (this.enableCaptureImage && !this.webcamImage) {
  //       this.messageService.add({
  //         severity: 'warn',
  //         summary: 'Image Required',
  //         detail: 'Image is not captured properly. Please capture image again.',
  //       });
  //       return;
  //     }
      
  //     const data = {
  //       browser_data: this.userData,
  //       esign_id: this.esignId,
  //       signatory_id: this.signatoryId,
  //       user_image: this.webcamImage,
  //     };
  //     this.eSignService.sendUserDetails(data).subscribe((res) => {});
  //   } else {
  //     return;
  //   }
  // }
  //------------------------------------------------------------------------------------------------//

  // handleImage(webcamImage: any) {
  //   console.log('webcamImage', webcamImage);
  //    if (!webcamImage) {
  //     this.orderService.logOrderTransaction(
  //       this.orderId || 'UNKNOWN_ID', 
  //       'IMAGE_CAPTURE_FAILED', 
  //       true, 
  //       'Camera not ready or image empty'
  //     );
  //     this.messageService.add({
  //       severity: 'warn',
  //       summary: 'Camera Not Ready',
  //       detail: 'Please wait for the camera to fully load before capturing.',
  //     });
  //     return;
  //   }
  //     const base64Data = webcamImage.split(',')[1] || '';
  //     const estimatedBytes = (base64Data.length * 3) / 4;
  
  //    if (estimatedBytes < 10000) {
  //     const sizeKb = (estimatedBytes / 1024).toFixed(2);
  //     this.orderService.logOrderTransaction(
  //       this.orderId || 'UNKNOWN_ID',
  //       'IMAGE_CAPTURE_QUALITY_POOR', 
  //       true, 
  //       `Image size too small: ${sizeKb} KB`
  //     );
  //     this.messageService.add({
  //       severity: 'warn',
  //       summary: 'Invalid Capture',
  //       detail: 'Camera was not ready. Please wait and try again.',
  //     });
  //     return;
  //   }
  //     this.webcamImage = webcamImage;
  //     const data = {
  //       user_image: this.webcamImage,
  //       order_id: this.orderId,
  //     };
  //     console.log('webcamImagetosend', data);
  //     const isMobileDevice = this.isMobile();
  //     if (this.signatoryDetails && this.signatoryDetails.face_live_detect) {
  //       this.eSignService.detectSignatoryFace(data).subscribe(
  //         (response: any) => {
  //           console.log('Face detection response:', response);

  //           if (response.content.live) {
  //             this.orderService.logOrderTransaction(this.orderId || 'UNKNOWN_ID', 'FACE_DETECTION_SUCCESS');
  //             this.messageService.add({
  //               severity: 'success',
  //               summary: 'Success',
  //               detail: 'Capture image successfully.',
  //             });
  //             if (isMobileDevice) {
  //               setTimeout(() => {
  //                 this.closeCam();
  //                 setTimeout(() => {
  //                   this.renderer.setStyle(
  //                     document.body,
  //                     'overflow-y',
  //                     'scroll'
  //                   );
  //                 }, 800);
  //               }, 300);
  //             } else {
  //               this.closeCam();
  //               this.renderer.setStyle(document.body, 'overflow-y', 'scroll');
  //             }
  //           } else {
  //             this.orderService.logOrderTransaction(
  //             this.orderId || 'UNKNOWN_ID', 
  //              'FACE_DETECTION_FAILED', 
  //               true, 
  //              'Liveness check failed (Not live)'
  //            );
  //             this.orderService.logOrderTransaction(
  //             this.orderId || 'UNKNOWN_ID', 
  //             'FACE_DETECTION_FAILED', 
  //             true, 
  //             'Liveness check failed (Not live)'
  //           );
  //           }
  //         },
  //         (error) => {
  //         console.error('Face detection error:', error);
  //         this.orderService.logOrderTransaction(
  //           this.orderId || 'UNKNOWN_ID', 
  //           'FACE_DETECTION_API_ERROR', 
  //           true, 
  //           error.message || 'API Error'
  //         );
  //           this.messageService.add({
  //             severity: 'error',
  //             summary: 'Error',
  //             detail: 'An error occurred while detecting the face.',
  //           });
  //         }
  //       );
  //     } else {
  //       this.orderService.logOrderTransaction(this.orderId || 'UNKNOWN_ID', 'IMAGE_CAPTURE_SUCCESS');
  //       this.messageService.add({
  //         severity: 'success',
  //         summary: 'Success',
  //         detail: 'Capture image successfully.',
  //       });

  //       if (isMobileDevice) {
  //         setTimeout(() => {
  //           this.closeCam();
  //           setTimeout(() => {
  //             this.renderer.setStyle(document.body, 'overflow-y', 'scroll');
  //           }, 600);
  //         }, 200);
  //       } else {
  //         setTimeout(() => {
  //           this.closeCam();
  //           this.renderer.setStyle(document.body, 'overflow-y', 'scroll');
  //         }, 100);
  //     }
  //   }
  // }

  sendUserDetails(): void {
  if (!this.userData) return;
  if (this.enableCaptureImage && !this.webcamImage) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Image Required',
      detail: 'Image is not captured properly. Please capture image again.',
    });
    return;
  }

  const data = {
    browser_data: this.userData,
    esign_id: this.esignId,
    signatory_id: this.signatoryId,
  };

  this.eSignService.sendUserDetails(data).subscribe({
    next: () => {
    },
    error: (err) => {
      this.isLoading = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Verification Failed',
        detail: err?.error?.message || 'Audit trail verification failed.',
      });
    }
  });
}

  handleImage(webcamImage: any) {
  if (!webcamImage) {
    return;
  }
  this.webcamImage = webcamImage;
  const data = {
    user_image: this.webcamImage,
    order_id: this.orderId,
  };
  console.log('webcamImagetosend', data);
  const isMobileDevice = this.isMobile();

  if (this.signatoryDetails && this.signatoryDetails.face_live_detect) {
    this.eSignService.detectSignatoryFace(data).subscribe({
      next: (response: any) => {
        console.log('Face detection response:', response);
        if (response.content.live) {
         this.analyticsService.logVerificationStep('FACE_DETECTION_SUCCESS', this.orderId);

          this.eSignService.syncCapturedImageInstantly(
            this.webcamImage,
            this.esignId,
            this.signatoryId
          );

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Capture image successfully.',
          });

          if (isMobileDevice) {
            setTimeout(() => {
              this.closeCam();
              setTimeout(() => {
                this.renderer.setStyle(document.body, 'overflow-y', 'scroll');
              }, 400);
            }, 1000);
          } else {
            this.closeCam();
            this.renderer.setStyle(document.body, 'overflow-y', 'scroll');
          }
        }
      }
    });
  } else {
    this.eSignService.syncCapturedImageInstantly(
      this.webcamImage,
      this.esignId,
      this.signatoryId
    );

   this.analyticsService.logVerificationStep('IMAGE_CAPTURE_SUCCESS', this.orderId);
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'Capture image successfully.',
    });

    if (isMobileDevice) {
      setTimeout(() => {
        this.closeCam();
        setTimeout(() => {
          this.renderer.setStyle(document.body, 'overflow-y', 'scroll');
        }, 400);
      }, 1000);
    } else {
      this.closeCam();
      this.renderer.setStyle(document.body, 'overflow-y', 'scroll');
    }
  }
}

  isMobile(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }
  openCam() {
    this.showWebcam = true;
  }

   handleInitError(error: WebcamInitError): void {
   this.analyticsService.logSystemError('camera_init', error.message, this.orderId);
    
    if (error.mediaStreamError && error.mediaStreamError.name === 'NotAllowedError') {
      alert("Please enable camera permissions in your browser settings.");
    }
  }

  closeCam() {
    if (this.signTypeDSC) {
      this.showWebcam = false;
      this.closeModel();
    } else {
      this.spinner.show();
      setTimeout(() => {
        this.showWebcam = false;
        this.sendUserDetails();
        this.getSignerDetails();
        this.spinner.hide();
      }, 1000);
      this.closeModel();
    }

    if (this.isMobile()) {
      this.stopAllCameraStreams();
      setTimeout(() => {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          console.log('Camera cleanup completed for mobile');
        }
      }, 150);
    }
  }

  sendDetails() {
    setTimeout(() => {
      this.sendUserDetails();
      this.getSignerDetails();
    }, 1000);
  }
  //-----------------------------------Same Signed Image ---------------------------------------//

  closeModel() {
    this.modalService.dismissAll();
  }

  loadSuccess(content) {
    this.modalService
      .open(content, {
        size: 'lg',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
  }

  closeTab() {
    this.closeModel();
    window.close();
  }

  loadCam(content) {
    this.openCam();
    this.modalService
      .open(content, {
        size: 'lg',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
  }

  closeTabCam() {
    const isMobileDevice = this.isMobile();
    if (this.isClosingModal) return;
    this.isClosingModal = true;

    const delay = isMobileDevice ? 400 : 0;

    setTimeout(() => {
      try {
        this.modalService.dismissAll();
        this.scrollPage();
      } catch (error) {
        console.log('Modal dismiss error (non-critical):', error);
      } finally {
        setTimeout(() => {
          this.isClosingModal = false;
        }, 100);
      }
    }, delay);
  }
  private stopAllCameraStreams() {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          devices.forEach((device) => {
            if (device.kind === 'videoinput') {
            }
          });
        })
        .catch((err) => console.log('Device enumeration error:', err));
    }
  }

  scrollPage() {
    const body = document.querySelector('body');
    this.renderer.setStyle(body, 'overflow', 'scroll');
  }

  base64ToUint8Array(base64: string): Uint8Array<ArrayBuffer> {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
  }

  //------------------------PDF Loader --------------------------------------------------------//


  onDocLoaded(event: { numPages: number }) {
    this.numPdfPages = event.numPages;

      if (this.positionDetails['ALL']) {
        const coordinates: Coordinates[] = this.positionDetails['ALL'];
        const newPositionDetails: PositionDetails = {};
        for (let i = 1; i <= this.numPdfPages; i++) {
          newPositionDetails[i.toString()] = coordinates;
        }
        delete this.positionDetails['ALL'];
        Object.assign(this.positionDetails, newPositionDetails);
      }

      this.cdr.detectChanges();
      this.gotoPagenumber(this.positionDetails);
  }


  onPageRendered(event: { pageNum: number; widthPx: number; heightPx: number }) {
    this.pageSizesPx[event.pageNum - 1] = { width: event.widthPx, height: event.heightPx };
    if (event.pageNum === 1) {
      this.pageHeight = event.heightPx;
    }
  }

  convertPtToPx(pt: number) {
    return (4 / 3) * pt;
  }

  // Scrolls the given page's own boundary into view — with one pdf-viewer
  // per page there's no single "current page" to reassign anymore.
  pageChange(pageNo: number) {
    this.pageVariable = pageNo;
    this.pdfViewer?.scrollToPage(pageNo);
  }

  getPosition(item, pageNum: number) {
    // Unlike sign-link (electronic), Aadhaar/DSC positions need this flip
    // regardless of sign_position — confirmed against a drag-dropped Aadhaar
    // position where removing the flip pushed the box to the bottom of the
    // page instead of the top where it was actually placed. The fixed
    // offset differs slightly between DRAG_DROP and predefined positions
    // (tuned empirically against real placements).
    const translateX = Math.floor(this.convertPtToPx(item.x1));
    const boundaryHeight = this.getPageHeight(pageNum);
    // These offsets were tuned for a 70px-tall box (70 for DRAG_DROP, 60 for
    // predefined). They now follow the box's real height, which keeps its bottom
    // edge exactly where it was and only changes the box size.
    const boxHeight = this.getBoxSizePx(item).height;
    const offset = this.signPosition === 'DRAG_DROP' ? boxHeight : boxHeight - 10;
    const translateY = Math.floor(
      boundaryHeight - this.convertPtToPx(item.y1) - offset
    );

    if (translateY < 0) {
      return `translate3d(${translateX}px, 5px, 0px)`;
    } else {
      return `translate3d(${translateX}px, ${translateY}px, 0px)`;
    }
  }

  // The signature area is drawn at the size this order will actually be signed
  // at (its own x1..x2 / y1..y2), instead of a fixed 120x70. New orders all use
  // the common signature box.
  getBoxSizePx(item): { width: number; height: number } {
    return getSignatureBoxSizePx(item);
  }

  convertPxToPt(px: number) {
    return (4 / 3) * px;
  }

  onCheckboxChange(event: any) {
    if (!this.isGeoFencingAllowed) {
      this.messageService.add({
        severity: 'error',
        summary: 'Access Denied',
        detail: 'Signing is only allowed from within India',
      });
      event.target.checked = false;
      return;
    }

    this.displayConsentModal = false;
    this.isChecked = event.target.checked;
    if (this.isChecked) {
      this.renderer.setStyle(document.body, 'overflow-y', 'scroll');
      this.enableCaptureImage
        ? this.loadCam(this.userImage)
        : this.sendDetails();
    } else {
      this.renderer.setStyle(document.body, 'overflow-y', 'hidden');
    }
  }
  gotoPagenumber(positionDetails: any) {
    this.signPages = Object.keys(positionDetails).map(Number).sort((a, b) => a - b);

    this.pageNo = this.signPages[0];
    if (this.signPages[0]) {
      this.pageChange(this.signPages[0]);
    }
  }

  onOtpMethod() {
    this.modalService
      .open(this.otpScreen, {
        size: 'lg',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
  }

  onOtpChange(otp: string) {
    this.otp = otp;
    if (this.otp.length == 6) {
      this.enableOtp = false;
    } else {
      this.enableOtp = true;
    }
  }

  startTimer() {
    setTimeout(() => {}, 1);
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      }
    }, 1000);
  }

  otpOnSubmit() {
    let data = {
      otp: this.otp,
      email: this.selectedUserEmail,
      contact_number: this.signatoryDetails?.contact_number,
    };
    this.eSignService.verifySendOtp(data).subscribe((res) => {
      this.modalService.dismissAll();
      this.messageService.add({
        severity: 'success',
        summary: 'OTP authenticated successfully',
        detail: '',
      });
      this.displayConsentModal = true;
      this.consentShown = true;
    });
  }

  sendOtpValidate() {
    this.eSignService
      .sendOtpToVerify(
        this.selectedUserEmail,
        this.orderId,
        this.signatoryId,
        this.signatoryDetails?.contact_number
      )
      .subscribe((res) => {
        let detailMsg = '';
        if (this.signatoryDetails?.is_sms) {
          detailMsg = 'An OTP has been sent to ' + this.signatoryDetails?.email;
          if (this.signatoryDetails?.contact_number) {
            detailMsg += ' and ' + this.signatoryDetails?.contact_number;
          }
        } else {
          detailMsg = 'An OTP has been sent to ' + this.signatoryDetails?.email;
        }
        this.messageService.add({
          severity: 'success',
          summary: 'OTP Validation',
          detail: detailMsg,
        });
        this.startTimer();
      });
  }

  resendOtp() {
    this.sendOtpLink = true;
    this.timeLeft = 60;
    this.startTimer();
    this.sendOtpValidate();
    this.showOtpComponent = false;
    this.otp = null;
    setTimeout(() => {
      this.showOtpComponent = true;
    }, 0);
  }

  //----------------------E-mudra----------------------------------------------//
  // loadEsignData(content) {
  //   this.isLoading = true;

  // // If webcam capture is enabled but no image is captured, show warning and exit
  //   if (this.enableCaptureImage && !this.webcamImage) {
  //     this.messageService.add({
  //       severity: 'warn',
  //       summary: 'Image Required',
  //       detail: 'Image is not captured properly. Please capture image again.',
  //     });
  //     this.isLoading = false;
  //     return;
  //   }

  //   this.sendUserDetails();
  //   this.eSignService
  //     .getExternalSignLink(this.signatoryId, this.orderId)
  //     .subscribe((res) => {
  //       if (!res['content'] || !res['content']['sign_url']) {
  //         this.isLoading = false;
  //         this.messageService.add({
  //           severity: 'warn',
  //           detail:
  //             res['message'] ||
  //             'Another signatory is currently signing. Please try after 10 minutes.',
  //         });
  //         return;
  //       }

  //       if (res['content'] && Object.keys(res['content']).length === 0) {
  //         this.messageService.add({ severity: 'warn', detail: res['message'] });
  //         return;
  //       } else {
  //         this.isLoading = false;
  //         const signUrl = res['content'].sign_url;
  //         if (this.urlValidator.isValidRedirectUrl(signUrl, DomainType.EMUDHRA)) {
  //           this.pdfSource =
  //             this.sanitizer.bypassSecurityTrustResourceUrl(signUrl);
  //         } else {
  //           return;
  //         }
  //         this.modalService
  //           .open(content, {
  //             size: 'md',
  //             ariaLabelledBy: 'modal-basic-title',
  //             backdrop: 'static',
  //             keyboard: false,
  //           })
  //           .result.then(
  //             (result) => {
  //               console.log(result);
  //             },
  //             (reason) => {
  //               console.log(reason);
  //             }
  //           );
  //       }
  //     });
  // }

loadEsignData(content) {
  if (this.isLoading) {
    return; // a click is already in flight - don't start a second eMudhra session
  }
  this.isLoading = true;

  if (this.enableCaptureImage && !this.webcamImage) {
    this.messageService.add({
      severity: 'error',
      summary: 'Image Required',
      detail: 'Camera access is required. Please ensure your webcam is enabled and photo is captured properly.',
    });
    this.isLoading = false;
    this.cdr.detectChanges();
    return;
  }

  this.eSignService.sendUserDetails({
    browser_data: this.userData,
    esign_id: this.esignId,
    signatory_id: this.signatoryId,
    user_image: this.webcamImage,
  }).subscribe({
    next: () => {
      this.eSignService.getExternalSignLink(this.signatoryId, this.orderId,this.selectMethod,this.selectedVerificationMethod).subscribe({
        next: (res: any) => {
          if (!res['content'] || !res['content']['sign_url']) {
            this.isLoading = false;
            this.messageService.add({
              severity: 'warn',
              detail: res['message'] || 'Another signatory is currently signing. Please try after 10 minutes.',
            });
            this.eSignService.checkForImageCaptureRefresh(res['message']);
            this.cdr.detectChanges();
            return;
          }

          if (res['content'] && Object.keys(res['content']).length === 0) {
            this.isLoading = false;
            this.messageService.add({ severity: 'warn', detail: res['message'] });
            this.eSignService.checkForImageCaptureRefresh(res['message']);
            this.cdr.detectChanges();
            return;
          }

          this.isLoading = false;
          const signUrl = res['content'].sign_url;
          if (this.urlValidator.isValidRedirectUrl(signUrl, DomainType.EMUDHRA)) {
            this.pdfSource = this.sanitizer.bypassSecurityTrustResourceUrl(signUrl);
          } else {
            this.eSignService.reportUnopenableSignLink(signUrl, this.orderId);
            this.cdr.detectChanges();
            return;
          }

          this.openEmudhraModal(content, {
            size: 'md',
            ariaLabelledBy: 'modal-basic-title',
            backdrop: 'static',
            keyboard: false,
          });
          this.cdr.detectChanges();
        },
        error: () => {
          this.isLoading = false;
          this.messageService.add({ severity: 'error', detail: 'Failed to fetch signing link.' });
          this.cdr.detectChanges();
        }
      });
    },
    error: (err) => {
      this.isLoading = false;
      const errMsg = err?.error?.message || 'Audit trail verification failed. Please allow camera access.';
      this.messageService.add({
        severity: 'error',
        summary: 'Verification Failed',
        detail: errMsg
      });
      this.eSignService.checkForImageCaptureRefresh(errMsg);
      this.cdr.detectChanges();
    }
  });
}

  loadEsignDataDSC() {

    // DSC
    // if (this.enableCaptureImage && !this.webcamImage) {
    //   this.messageService.add({
    //     severity: 'warn',
    //     summary: 'Image Required',
    //     detail: 'Image is not captured properly. Please capture image again.',
    //   });
    //   this.isLoading = false;
    //   return;
    // }

    // this.enableCaptureImage ? this.loadCam(this.userImage): this.sendDSCSignFORM();
    this.sendDSCSignFORM();
  }

  // sendDSCSignFORM() {
  //   this.sendUserDetails();

  //   this.eSignService
  //     .getExternalSignLink(this.signatoryId, this.orderId)
  //     .subscribe((res) => {
  //       if (!res['content'] || !res['content']['sign_url']) {
  //         this.isLoading = false;
  //         this.messageService.add({
  //           severity: 'warn',
  //           detail:
  //             res['message'] ||
  //             'Another signatory is currently signing. Please try after 10 minutes.',
  //         });
  //         return;
  //       }

  //       if (res['content'] && Object.keys(res['content']).length === 0) {
  //         this.messageService.add({ severity: 'warn', detail: res['message'] });
  //         return;
  //       } else {
  //         const signUrl = res['content'].sign_url;
  //         if (this.urlValidator.isValidRedirectUrl(signUrl, DomainType.EMUDHRA)) {
  //           this.pdfSource =
  //             this.sanitizer.bypassSecurityTrustResourceUrl(signUrl);
  //         } else {
  //           return;
  //         }
  //         this.parameters = {
  //           Parameter1: res['content'].emudhra_gateway.Parameter1,
  //           Parameter2: res['content'].emudhra_gateway.Parameter2,
  //           Parameter3: res['content'].emudhra_gateway.Parameter3,
  //         };

  //         this.modalService
  //           .open(this.emudhraSignDSC, {
  //             size: 'md',
  //             ariaLabelledBy: 'modal-basic-title',
  //             backdrop: 'static',
  //             keyboard: false,
  //             centered: true,
  //           })
  //           .result.then(
  //             (result) => {
  //               console.log(result);
  //             },
  //             (reason) => {
  //               console.log(reason);
  //             }
  //           );
  //         setInterval(() => {
  //           this.submitForm();
  //         }, 10000);
  //       }
  //     });
  // }

  sendDSCSignFORM() {
  // DSC Strict Guard
  if (this.enableCaptureImage && !this.webcamImage) {
    this.messageService.add({
      severity: 'error',
      summary: 'Image Required',
      detail: 'Camera access is required. Please ensure your webcam is enabled and photo is captured properly before DSC.'
    });
    return;
  }

  if (this.isLoading) {
    return; // a click is already in flight - don't start a second eMudhra session
  }
  this.isLoading = true;

  // Synchronous Chaining
  this.eSignService.sendUserDetails({
    browser_data: this.userData,
    esign_id: this.esignId,
    signatory_id: this.signatoryId,
    user_image: this.webcamImage
  }).subscribe({
    next: () => {
      this.eSignService.getExternalSignLink(this.signatoryId, this.orderId,this.selectMethod,this.selectedVerificationMethod).subscribe({
        next: (res: any) => {
          if (!res['content'] || !res['content']['sign_url']) {
            this.isLoading = false;
            this.messageService.add({
              severity: 'warn',
              detail: res['message'] || 'Another signatory is currently signing. Please try after 10 minutes.'
            });
            this.eSignService.checkForImageCaptureRefresh(res['message']);
            return;
          }

          if (res['content'] && Object.keys(res['content']).length === 0) {
            this.isLoading = false;
            this.messageService.add({ severity: 'warn', detail: res['message'] });
            this.eSignService.checkForImageCaptureRefresh(res['message']);
            return;
          }

          const signUrl = res['content'].sign_url;
          if (this.urlValidator.isValidRedirectUrl(signUrl, DomainType.EMUDHRA)) {
            this.pdfSource = this.sanitizer.bypassSecurityTrustResourceUrl(signUrl);
          } else {
            this.isLoading = false;
            this.eSignService.reportUnopenableSignLink(signUrl, this.orderId);
            this.cdr.detectChanges();
            return;
          }

          this.parameters = {
            Parameter1: res['content'].emudhra_gateway?.Parameter1,
            Parameter2: res['content'].emudhra_gateway?.Parameter2,
            Parameter3: res['content'].emudhra_gateway?.Parameter3
          };

          this.openEmudhraModal(this.emudhraSignDSC, {
            size: 'md',
            ariaLabelledBy: 'modal-basic-title',
            backdrop: 'static',
            keyboard: false,
            centered: true
          });

          setTimeout(() => {
            this.submitForm();
          }, 10000); // Kept the original 10-second timeout
        },
        error: () => {
          this.isLoading = false;
          this.messageService.add({ severity: 'error', detail: 'Failed to fetch DSC signing link.' });
        }
      });
    },
    error: (err) => {
      this.isLoading = false;
      const errMsg = err?.error?.message || 'Audit trail verification failed. Cannot proceed to DSC.';
      this.messageService.add({
        severity: 'error',
        summary: 'Verification Failed',
        detail: errMsg
      });
      this.eSignService.checkForImageCaptureRefresh(errMsg);
    }
  });
}


  showFileCorruptionModal() {
    this.showFileCorruptedDialog = true;
  }

  onRetryClicked() {
    const url = new URL(window.location.href);
    if(this.urlValidator.isValidRedirectUrl(url.toString(), DomainType.DOQFY)){
      url.searchParams.delete('retry');
      window.history.replaceState({}, document.title, url.toString());
      this.showFileCorruptedDialog = false;
    } 
  }
  onCloseModal() {
    this.showFileCorruptedDialog = false;
  }

  submitForm() {
    const form = document.getElementById('signDocForm') as HTMLFormElement;
    form.submit();
  }

  closeEmudhraModel() {
    this.modalService.dismissAll();
  }

  // The eMudhra session runs inside this modal. Hold the page's 5-minute
  // auto-reload while it is open (a reload ends the signer's session mid-OTP)
  // and give them a fresh 5 minutes if they close it.
  private openEmudhraModal(content: TemplateRef<any>, options: NgbModalOptions) {
    clearInterval(this.sessionTimerInterval);
    const restartTimer = () => this.startSessionTimer();
    this.modalService.open(content, options).result.then(restartTimer, restartTimer);
  }

  shareToEmail() {
    if (this.isEmailButtonDisabled) {
      this.messageService.add({
        severity: 'warn',
        detail: `Please wait ${this.emailCooldownTime} seconds before sending again.`,
        life: 3000,
      });
      return;
    }

    const payload = {
      esign_id: this.queryParams.esign_id,
      signatory_id: this.queryParams.signatory_id,
      notify_type: 'ESIGN_SUCCESS',
    };

    this.isEmailButtonDisabled = true;

    this.eSignService.sendEmailNotification(payload).subscribe({
      next: (response) => {
        // console.log('Email notification sent successfully', response);
        this.messageService.add({
          severity: 'success',
          detail: 'Signed document has been sent to your email successfully.',
          life: 3500,
        });

        // Start cooldown timer
        this.startEmailCooldown();
      },
      error: (error) => {
        // console.error('Error sending email notification', error);
        this.messageService.add({
          severity: 'error',
          detail: 'Failed to send email. Please try again.',
          life: 3500,
        });
        // Re-enable button on error
        this.isEmailButtonDisabled = false;
      },
    });
  }

  startEmailCooldown() {
    this.emailCooldownTime = 10;

    this.emailCooldownInterval = setInterval(() => {
      this.emailCooldownTime--;

      if (this.emailCooldownTime <= 0) {
        this.isEmailButtonDisabled = false;
        clearInterval(this.emailCooldownInterval);
      }
    }, 1000);
  }

  printDocument() {
    const documentBase64 = this.signerData?.document;
    // console.log('document===========>', documentBase64);

    if (documentBase64) {
      try {
        const byteArray = this.base64ToUint8Array(documentBase64);
        const file = new Blob([byteArray], {
          type: 'application/pdf',
        });
        const fileURL = URL.createObjectURL(file);

        const iframe = document.createElement('iframe');
        iframe.style.position = 'fixed';
        iframe.style.right = '0';
        iframe.style.bottom = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = 'none';
        iframe.style.visibility = 'hidden';

        document.body.appendChild(iframe);
        iframe.src = fileURL;

        iframe.onload = () => {
          setTimeout(() => {
            try {
              iframe.contentWindow?.focus();
              iframe.contentWindow?.print();

              const cleanupHandler = () => {
                setTimeout(() => {
                  if (document.body.contains(iframe)) {
                    document.body.removeChild(iframe);
                  }
                  URL.revokeObjectURL(fileURL);
                }, 100);
              };

              iframe.contentWindow?.addEventListener(
                'afterprint',
                cleanupHandler
              );

              setTimeout(cleanupHandler, 60000); // 60 seconds fallback
            } catch (e) {
              console.error('Print error:', e);
              if (document.body.contains(iframe)) {
                document.body.removeChild(iframe);
              }
              URL.revokeObjectURL(fileURL);
            }
          }, 500);
        };

        // console.log('Printing document...');
      } catch (error) {
        // console.error('Error printing document:', error);
      }
    } else {
      // console.error('Document not available for printing');
    }
  }

  downloadDocument() {
    const documentBase64 = this.signerData?.document;
    // console.log('document===========>', documentBase64);
    const esignId = this.signatoryDetails?.esign_id;

    if (documentBase64) {
      try {
        const byteArray = this.base64ToUint8Array(documentBase64);
        const file = new Blob([byteArray], {
          type: 'application/pdf',
        });
        const fileURL = URL.createObjectURL(file);

        const link = document.createElement('a');
        link.href = fileURL;

        const sanitizedId = esignId
          ? esignId.replace(/ /g, '_')
          : `signed_document_${Date.now()}`;

        const filename = `${sanitizedId}.pdf`;
        link.download = filename;
        link.click();
        URL.revokeObjectURL(fileURL);
      } catch (error) {
        console.error('Error downloading document:', error);
      }
    } else {
      // console.error('Document not available in signerData');
    }
  }
}